<template>
    <div :class="[layoutState.layoutStyle, layoutState.menuStyle]">
        <div v-if="isLoading" class="loader-overlay">
            <div class="spinner-border spinner-border-reverse align-self-center loader-lg text-secondary">Loading...</div>
        </div>
        <app :style="{ opacity: isLoading ? '0' : '1' }"></app>
    </div>
</template>
<script setup>
    import { computed } from "vue";

    import "./assets/sass/app.scss";

    import { useMeta } from "./composables/use-meta";
    import { useStore } from "vuex";
    import { useLayout } from '@/composables/useLayout';

    useMeta({ title: "Cursos" });

    const store = useStore();

    const isLoading = computed(() => store.getters.isLoading);
    const { layoutState } = useLayout();
    
    // Definir componentes diretamente no script setup
    const components = {
        app: appLayout,
    };
</script>
<script>
    // layouts
    import appLayout from "./layouts/app-layout.vue";

    export default {
        components: {
            app: appLayout,
        },
    };
</script>
